import { BehaviorSubject } from "rxjs";
import produce from "immer";

import { fetchWrapper } from "data/FetchWrapper";
import { queryService } from "services";
// import { history } from 'data/History';

const topics$ = new BehaviorSubject([]);
const current$ = new BehaviorSubject(null);
const queries$ = new BehaviorSubject(null);
const abort$ = new BehaviorSubject(new AbortController());
const baseUrl = `/api/topic`;

const _fetch = () => {
  current(null);
  return fetchWrapper
    .get(`${baseUrl}`, abort$.value.signal)
    .then((topics) => {
      topics$.next(topics);
      return topics;
    })
    .catch((e) => console.warn(e));
};

const create = (topic) => {
  return fetchWrapper
    .post(`${baseUrl}`, topic, abort$.value.signal)
    .then((topic) => {
      const topics = produce(topics$.value, (topics) => {
        topics.push(topic);
      });
      topics$.next(topics);
      current$.next(topic);
      return topic;
    });
};

const current = (topic) => {
  current$.next(topic);
  queries$.next(null);
  return fetchWrapper
    .get(
      `/api/query/by-topic/${(topic && topic.id) || "none"}`,
      abort$.value.signal
    )
    .then((queries) => {
      queries$.next(queries);
      return queries;
    })
    .catch((e) => {
      queries$.next([]);
      return [];
    });
};

const edit = (topic) => {
  return fetchWrapper
    .put(`${baseUrl}/${topic.id}`, topic, abort$.value.signal)
    .then((topic) => {
      topics$.next(topics$.value.map((_) => (_.id === topic.id ? topic : _)));
      const current = current$.value;
      if (current && current.id === topic.id) {
        current$.next(topic);
      }
      return topic;
    });
};

const _delete = (topicId) => {
  return fetchWrapper
    .delete(`${baseUrl}/${topicId}`, null, abort$.value.signal)
    .then((topic) => {
      topics$.next(topics$.value.filter((_) => _.id !== topicId));
      const c = current$.value;
      if (c && c.id === topicId) {
        current(null);
      }
      const query = queryService.query$.value;
      if (query && query.topicId === topicId) {
        queryService.query$.next(null);
      }
      return true;
    })
    .catch((e) => {
      return false;
    });
};

const abort = () => {
  abort$.value.abort();
  abort$.next(new AbortController());
};

export const topicService = {
  create,
  current,
  edit,
  delete: _delete,
  fetch: _fetch,
  topics$,
  current$,
  queries$,
  abort,
};
